<template>
  <div class="queryContent">
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("query.type.hscode") }} </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="query-header scroll-border-dom">
      <div
        :class="[
          'query-header-wrap',
          'boxshadow1',
          historyItem && historyItem.length > 0 ? 'hashis' : ''
        ]"
      >
        <div :class="['query-slogon', importer ? 'mic' : '']">税则查询</div>
        <div class="query-inputs">
          <div
            :class="[importer ? 'mic' : '', 'inputs', 'clearfix']"
            @keyup="escEvent"
          >
            <!-- <Import
              class="im"
              ref="im"
              :width="'200%'"
              :currentState="currentState"
              @handleClick="handleClick"
              @closeDropdown="closeDropdown"
            ></Import> -->
            <Product
            placeholderText="商品编码/商品名称"
              class="pr"
              ref="pr"
              :currentState="currentState"
              @handleClick="handleClick"
              @closeDropdown="closeDropdown"
            ></Product>
          </div>
          <div class="btn-wrap clearfix">
            <Button
              type="primary"
              class="btn search"
              @click.prevent="searchHandle"
            >
              <span v-if="!isShowLoader"><span>搜索</span></span>
              <span v-else>{{ $t("common.loading") }}</span>
            </Button>
            <Button
              class="btn reset"
              type="primary"
              @click.prevent="resetHandle"
              :disabled="isShowLoader"
              ><span>{{ $t("btn.reset") }}</span></Button
            >
          </div>
        </div>
        <div class="query_history" v-if="historyItem && historyItem.length > 0">
          <span class="his_title">最近搜索：</span>
          <div class="his_values">
            <span
              class="his_value"
              v-for="(item, index) in historyItem"
              :key="index"
            >
              <span class="his_value_wrap" @click="selectHistoryItem(item)">
                <Tooltip :content="`${item.id}${item.text}`" :max-width="250">
                  <span class="his_id">{{ item.id }}</span
                  ><span class="his_text">{{ item.text | truncate(8) }}</span>
                </Tooltip>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="results">
      <div class="results-wrap">
        <div class="results-content">
          <div style="position: relative">
            <HsCodeContentZH
              :dataSet="dataSet"
              :crumbs="crumbs"
              :ciq="ciq"
              :modelField="modelField"
              :ranks="ranks"
              :importArea="importArea"
              :hscode="hscode"
              class="r-main"
            />
          </div>
          <!-- <HsCodeSider class="r-sidebar" /> -->
        </div>
      </div>
      <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Import from "../common/Import";
import Product from "../common/Product";
import HsCodeContentZH from "./zh-CN/HsCodeContent";
import HsCodeSider from "./HsCodeSider";
import Loader from "../layout/Loader";
import { createNamespacedHelpers } from "vuex";
const {
  mapState: mapSearchState,
  mapMutations: mapSearchMutations
} = createNamespacedHelpers("search");
const {
  mapState: mapDataState,
  mapGetters: mapDataGetters
} = createNamespacedHelpers("data");

export default {
  name: "HsCode",
  props: ["importer", "hscode"],
  components: { Import, Product, HsCodeSider, HsCodeContentZH, Loader },
  data() {
    return {
      $isIE: Vue._customVars.isIE,
      searchItem: null,
      isShowLoader: false,
      crumbs: [],
      dataSet: {},
      importArea: {},
      ranks: [],
      ciq:{},
      modelField:{},
      t: "",
      searchDoing: false,
      isShowSearchMsg: true
    };
  },
  watch: {
    importerAll(newVal) {
      if (newVal.length > 1 && !this.importer) {
        this.gotoHs();
      }
    },
    productReady(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.initInputValue();
        }, 200);
      }
    },
    importer(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    },
    hscode(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    },
    $route() {
      this.t = this.$route.query._t;
    },
    t(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue();
        this.requestData();
      }
    }
  },
  computed: {
    currentState: {
      get() {
        return this.getActiveName();
      },
      set(v) {
        this.updateState(v);
      }
    },
    ...mapSearchState({
      historyImportItem: state => state.history.importer,
      historyItem: state => state.history.products
    }),
    apiPrice() {
      if (this._.isEmpty(this.apiValue)) {
        return null;
      } else {
        return this.getApiValue();
      }
    },
    ...mapDataState(["importerAll", "productReady"]),
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  created() {
    if (this.importerAll.length > 1 && !this.importer) {
      this.gotoHs();
    }
    this.currentState = "hscode";
    this.requestData();
  },
  mounted() {
    // let chana = { id: 27, text: "中国" };
    // this.$refs.im.setDefaultValue(chana);
    this.$nextTick(() => {
      this.currentState = "hscode";
      if (!this._.isEmpty(this.getTopProduct()())) {
        this.initInputValue();
      }
      if (this.$route.params.hscode != 1) {
        this.$refs.pr.setDefaultValue({ id: this.$route.params.hscode }, true);
      }
      this.$root.$on("QuickShowEvent", () => {
        this.currentState = "hscode";
        try {
          this.closeAllDropdown(!this.$data.$isIE);
        } catch (e) {}
      });
      // let queryHeaderDom = document.querySelector(".query-header");
      // let resultDom = document.querySelector(".results");
      // let footer = document.querySelector("footer");
      // resultDom.style.minHeight =
      //   this._h.getWinHeight() -
      //   this._h.getOuterElSize(footer).height -
      //   Math.abs(
      //     this._h.getScrollTop() -
      //       Math.abs(this._h.getOffset(queryHeaderDom).bottom)
      //   ) +
      //   "px";
    });
  },
  methods: {
    gotoHs() {
      return;
      if (this.importerAll.length > 1 && !this.importer) {
        let zg = _.find(this.importerAll, o => /中国/i.test(o.name));
        if (zg) {
          this.$router.push({
            name: "queryHsCode",
            params: { importer: zg.id, hscode: this.hscode }
          });
        } else {
          this.$router.push({
            name: "queryHsCode",
            params: { importer: this.importerAll[0].id, hscode: this.hscode }
          });
        }
      }
    },
    delayRequestData() {
      setTimeout(() => {
        this.requestData();
      }, 500);
    },
    requestData() {
      if (this.isShowLoader) {
        // this.delayRequestData()
        return;
      }
      if (this.hscode == 1) return;
      this.$Loading.start();
      this._h.scrollTop();
      this.isShowLoader = true;
      this.$api.query.hs(this.importer, this.hscode, {
        success: response => {
          this.$Loading.finish();
          this.$refs.pr && this.$refs.pr.closeDowndown(false);
          if (response.data.code === 200) {
            if (!this._.isEmpty(response.data.data.hs)) {
              this.crumbs = response.data.data.crumbs || [];
              this.dataSet = response.data.data.hs || {};
              this.importArea = response.data.data.importArea || {};
              this.ranks = response.data.data.ranks || [];
              this.ciq  = response.data.data.ciq || {};
              this.modelField =  response.data.data.modelField || {};
           
            } else {
              this.$Message.warning({
                content: this.$t("query.message.product_error"),
                closable: true
              });
            }
          } else if (response.data.code === 404) {
            this.$Message.warning({
              content: this.$t("query.message.product_error"),
              closable: true
            });
            // } else if (response.data.code === 505) {
            //   this.GMessage('warning', this.$t('query.message.search_frequent'), '去充值', { name: 'Recharge' })
          } else if (response.data.code === 401) {
            // this.GMessage('warning', this.$t('query.message.search_perm_limit2'), '登录', { path: '/my' })
            this.$Message.error({
              content: this.$t("query.message.search_perm_limit2"),
              closable: false
            });
            // } else if (response.data.code === 506) {
            //   this.GMessage('warning', this.$t('query.message.search_perm_limit'), '登录', { path: '/my' })
          } else {
            this.$Message.warning({content: response.data.message, closable: true})
          }
          this.isShowLoader = false;
        },
        error: errorMsg => {
          this.isShowLoader = false;
          this.$Message.error({
            content: this.$t("common.tryAgain"),
            closable: true
          });
          this.$Loading.error();
        }
      });
    },
    initInputValue() {
      if (this.importer && this.importerAll.length > 1) {
        let impoterItem = this.getImporterById()(this.importer);
        if (!this._.isEmpty(impoterItem)) {
          this.$refs.im.setDefaultValue({
            id: impoterItem.id,
            text: impoterItem.name
          });
        } else if (!this._.isEmpty(this.historyImportItem)) {
          // this.$refs.im.setDefaultValue(this.historyImportItem[0])
        }
      }
      this.searchItem = this.getProductByCode()(this.hscode);
      if (!this._.isEmpty(this.searchItem)) {
        this.$refs.pr.setDefaultValue({
          id: this.searchItem.code,
          text: this.searchItem.name
        });
      } else if (!this._.isEmpty(this.historyItem)) {
        // this.searchItem = this.historyItem[0]
        // this.$refs.pr.setDefaultValue(this.historyItem[0])
      }
    },
    selectHistoryItem(item) {
      this.$refs.pr.setDefaultValue(item);
      // this.$refs.pr.isShowInput = true;
      this.searchHandle();
    },
    resetHandle() {
      if (this.$refs.pr) {
        this.$refs.pr.setDefaultValue(false);
      }
      this.crumbs = [];
      this.dataSet = {};
      this.importArea = {};
      this.ranks = [];
      this.ciq = {};
      this.modelField = {};
      this.updateHistory({
        products: 1
      });
      this.$router.push({
        name: "queryHsCode",
        params: this.importer
          ? {
              importer: this.$refs.im.value.id,
              hscode: 1
            }
          : {
              hscode: 1
            },
        query: { _t: new Date().getTime() }
      });
      if (this.$refs.im) {
        // this.$refs.im.resetContent(false);
      }
    },
    searchByHS(hasDropdown = false) {
      this.searchDoing = false;
      if (this.importer) {
        if (this.$refs.im.text && !this.$refs.im.value.id) {
          if (!hasDropdown && this.isShowSearchMsg) {
            this.$Message.warning({
              content: this.$t("query.message.import_error"),
              closable: true
            });
          }
          this.isShowSearchMsg = true;
          return;
        }
      }
      if (!this.$refs.pr.text) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({
            content: this.$t("query.message.product_error"),
            closable: true
          });
        }
        this.isShowSearchMsg = true;
      } else {
        this.jfNotice2();
      }
    },
    searchHandle() {
      if (this.searchDoing) return;
      this.searchDoing = true;
      if (!this.$refs.pr || (this.importer && !this.$refs.im)) return;
      if (
        this.$refs.pr.isShowDropDown ||
        (this.importer && this.$refs.im.isShowDropDown)
      ) {
        setTimeout(() => {
          this.searchByHS(true);
        }, 150);
      } else {
        this.searchByHS();
      }
    },
    jfNotice2() {
      if (this.$i18n.locale === "zh-CN") {
        this.GJFNotice(status => {
          if (status) {
            let jf = this.getApiValue()(3);
            if (jf && jf.integral && jf.integral > 0) {
              this.GConfirm(
                `本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`,
                status => {
                  if (status) {
                    this.searchHandleAfter();
                  }
                }
              );
            } else {
              this.searchHandleAfter();
            }
          } else {
            this.searchHandleAfter();
          }
        });
      } else {
        this.searchHandleAfter();
      }
    },
       searchHandleAfter() {
      if (!this.$refs.pr || (this.importer && !this.$refs.im)) return;
      this.importer &&
        this.$refs.im &&
        this.$refs.im.setValueFromDefaultPlaceholder();
      this.$refs.pr && this.$refs.pr.setValueFromDefaultPlaceholder();
      if (this.importer) {
        if (!this.$refs.im.text) {
          this.$Message.warning({
            content: this.$t("query.message.import_empty"),
            closable: true
          });
          return;
        }
        if (!this.$refs.im.value.id) {
          this.$Message.warning({
            content: this.$t("query.message.import_error"),
            closable: true
          });
          return;
        }
      }
      if (!this.$refs.pr.text) {
        this.$Message.warning({
          content: this.$t("query.message.product_empty"),
          closable: true
        });
        return;
      }
      if (!this.$refs.pr.text) {
        this.$Message.warning({
          content: this.$t("query.message.product_error"),
          closable: true
        });
        return;
      }
      if (this.importer) {
        this.updateHistory({
          importer: this.$refs.im.value,
          products: this.$refs.pr.value
        });
      } else {
        this.updateHistory({
          products: this.$refs.pr.value
        });
      }
      // debugger;
      this.$router.push({
        name: "queryHsCode",
        params: this.importer
          ? {
              importer: this.$refs.im.value.id,
              hscode: this.$refs.pr.text
            }
          : {
              hscode: this.$refs.pr.text
            },
        query: { _t: new Date().getTime() }
      });
    },
    handleClick(event, componentName) {
      switch (componentName) {
        case "importer":
          this.$refs.pr && this.$refs.pr.closeDowndown(false);
          break;
        case "product":
          this.$refs.im && this.$refs.im.closeDowndown(false);
          break;
      }
    },
    enterEvent(event, componentName) {
      switch (componentName) {
        case "im":
          if (this.$refs.im && this.$refs.im.text) {
            this.setAutomatic(componentName);
          }
          break;
        case "pr":
          if (this.$refs.pr.text) {
            this.setAutomatic(componentName);
          }
          break;
      }
      setTimeout(() => {
        // if (this.$refs.pr.value.id) {
        this.isShowSearchMsg = false;
        this.searchHandle();
        // }
      }, 300);
    },
    escEvent(event) {
      if (event && event.keyCode === 27) {
        this.closeAllDropdown();
      }
    },
    tabEvent(event, componentName) {
      this.setAutomatic(componentName);
    },
    closeDropdown(event, componentName) {
      this.setAutomatic(componentName, false);
    },
    closeAllDropdown(isBlur = true) {
      this.importer && this.$refs.im.closeDowndown(isBlur);
      this.$refs.pr.closeDowndown(isBlur);
    },
    setAutomatic(componentName, isNextDropDown = true) {
      switch (componentName) {
        case "im":
          if (this.$refs.im) {
            this.$refs.im.closeDowndown(true);
            if (isNextDropDown || this.$refs.im.text) {
              if (!this.$refs.pr.text) {
                this.$refs.pr.inputClick();
              }
            }
          }
          break;
        case "pr":
          this.$refs.pr.closeDowndown(false);
          break;
      }
    },
    ...mapSearchState({
      getActiveName: state => state.activeName
    }),
    ...mapSearchMutations(["updateState", "updateHistory"]),
    ...mapDataGetters([
      "getApiValue",
      "getImporterById",
      "getProductByCode",
      "getTopProduct"
    ])
  }
};
</script>
<style scoped>
.chris_sd {
  position: absolute;
  width: 100px;
  right: 60px;
  top: -25px;
  z-index: 100;
}
.im {
  width: 0%;
  display: none;
  float: left;
  border-right: 0 none !important;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.mic .im {
  width: 29%;
  display: block;
}
.mic .pr {
  width: 71%;
  float: left;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.results {
  position: relative;
}
.queryContent .query-header {
  margin-top: 20px;
  background: #fff;
}
.queryContent .query-header-wrap,
.results-wrap {
  width:1400px;
  margin: 0 auto;
  padding: 16px 16px 20px;
}
.results-wrap {
  padding: 0;
}
.queryContent .query-header-wrap.hashis {
  padding-bottom: 6px;
}
.query-slogon {
  color: #323232;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 5px;
}
.query-slogon.mic {
  padding: 0 0 12px;
}
.query-inputs {
  /* position: relative; */
  display: flex;
  padding-left: 1px;
}
.query-inputs .inputs {
  width: 65%;
  display: inline-block;
}
.query-inputs .inputs >>> .wrap {
  padding-left: 0;
}
.query-inputs .inputs >>> .search-input-item.pr .wrap .title {
  display: none;
}
.query-inputs .inputs.mic >>> .search-input-item.pr .wrap .title {
  display: block;
}
.query-inputs >>> .search-input-item .value {
  padding: 1px;
}
.btn-wrap {
  /* position: absolute; */
  /* left: 65%; */
  margin-left: 8px;
  bottom: 0;
  display: inline-block;
  width: 30%;
  padding: 3px 0;
  height: 40px;

}
.btn {
  width: 40%;
  border: 1px solid #1f8afd;
  border-radius: 3px;
  height: 100%;
  float: left;
  /*font-size: 12px;*/
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.btn span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.btn.search {
  border-color: #2f6fb9;
  background-color: #2f6fb9;
  color: #fff;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  letter-spacing: 2px;
}
.btn.ivu-btn-loading {
  cursor: default;
}
.btn.ivu-btn-loading span {
  position: static;
  transform: none;
}
.btn.reset {
  background-color: #fff;
  border-color: #2f6fb9;
  color: #2f6fb9;
  margin-left: 20px;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  letter-spacing: 2px;
}
.btn.reset[disabled] {
  color: #bbbec4;
  /*background-color: #f7f7f7;*/
  border-color: #dddee1;
  cursor: default;
}
.query_history {
  margin-top: 10px;
  font-size: 14px;
  color: #999;
  position: relative;
  padding-left: 75px;
}
.query_history .his_title {
  position: absolute;
  left: 0;
  top: 0;
}
.query_history .his_values {
  display: flex;
  white-space: nowrap;
  flex-wrap: wrap;
}
.query_history .his_value {
  padding: 0 14px 8px 0;
  display: block;
}
.query_history >>> .ivu-tooltip-inner {
  white-space: normal;
}
.query_history .his_value_wrap:hover {
  color: #0774b5;
  cursor: pointer;
}
.results {
  /* background-color: #fff; */
  position: relative;
  margin-top: 30px;
}
.results-wrap {
  /* padding-left: 1px; */
}
.shadow-divide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.5);
  z-index: 1;
  height: 5px;
  background-color: #fff;
}
.breadcrumbs {
  /*font-size: 12px;*/
  font-size: 14px;
  color: #333;
  width: 90%;
  margin: 5px 0 18px;
}
.breadcrumbs span {
  cursor: default;
}
.breadcrumbs span.last {
  color: #1f8afd;
  /*font-weight: bold;*/
}
.results-content {
  /* margin-top: 15px; */
  position: relative;
  /* padding-right: 235px; */
}
.r-main {
}
.r-sidebar {
  position: absolute;
  top: 0;
  right: 0;
  width: 220px;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.5);
}
</style>




// WEBPACK FOOTER //
// src/components/query/HsCode.vue